import React, { useEffect } from "react";
import { Modal, Header, Button } from "semantic-ui-react";
import WithEventWarning from "../WithEventWarning/WithEventWarning";
import SharedFunctions from "../../utils/SharedFunctions";
import { FAILURE_TO_DELIVER_MODAL } from "../../utils/constants/componentConstants";
import { GeneralErrorMessage } from "../../utils/Constants";

const FailureToDeliverModal = ({
  open,
  onClose,
  isManualPack,
  className,
  message,
  errorCode,
  isAFrameMixed,
}) => {
  useEffect(() => {
    function onOpen() {
      SharedFunctions.LogPopupShownEvent(FAILURE_TO_DELIVER_MODAL);
    }
    if (open) {
      onOpen();
    }
  }, [open]);

  return (
    <Modal
      open={open}
      size="small"
      className={className}
      closeOnEscape={false}
      closeOnDimmerClick={false}
    >
      <Header icon="warning sign" color="red" content="Något gick fel vid utleverans!" />
      <Modal.Content>
        <h1>{message ?? GeneralErrorMessage}</h1>
        {errorCode && <h5>ID: ({errorCode})</h5>}
      </Modal.Content>
      <Modal.Actions>
        <Button primary onClick={onClose}>
          {isManualPack || isAFrameMixed ? "OK" : "Lådan är bortplockad"}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
export default WithEventWarning(FailureToDeliverModal);
